import { css } from 'styled-components'

type CustomTypographyProps = {
  body12?: boolean
  body14?: boolean
  body16?: boolean
  body20?: boolean
  caption12?: boolean
  title28?: boolean
  title40?: boolean
  title52?: boolean
}

const caption12Css = ({ caption12 }: CustomTypographyProps) =>
  caption12 &&
  css`
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.08em;
  `

const body12Css = ({ body12 }: CustomTypographyProps) =>
  body12 &&
  css`
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
  `

const body14Css = ({ body14 }: CustomTypographyProps) =>
  body14 &&
  css`
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.02em;
  `

const body16Css = ({ body16 }: CustomTypographyProps) =>
  body16 &&
  css`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
  `

const body20Css = ({ body20 }: CustomTypographyProps) =>
  body20 &&
  css`
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.02em;
  `

const title52Css = ({ title52 }: CustomTypographyProps) =>
  title52 &&
  css`
    font-size: 52px;
    line-height: 60px;
    letter-spacing: 0.01em;
  `

const title40Css = ({ title40 }: CustomTypographyProps) =>
  title40 &&
  css`
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 0.01em;
  `

const title28Css = ({ title28 }: CustomTypographyProps) =>
  title28 &&
  css`
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0.01em;
  `

export type { CustomTypographyProps }
export {
  body12Css,
  body14Css,
  body16Css,
  body20Css,
  caption12Css,
  title28Css,
  title40Css,
  title52Css,
}
